import AttendancePage from '../../components/attendancePage';

const GeneralStaffAttendance = () => (
  <AttendancePage userType="generalStaff" title="General Staff Attendance" />
);

export default GeneralStaffAttendance;
